var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marker-pin-03"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7995 18.9333C11.6328 14.7666 17.4661 14.2818 17.4661 8.93327C17.4661 5.25137 14.4814 2.2666 10.7995 2.2666C7.11758 2.2666 4.13281 5.25137 4.13281 8.93327C4.13281 14.2818 9.96615 14.7666 10.7995 18.9333Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7995 11.4333C12.1802 11.4333 13.2995 10.314 13.2995 8.93327C13.2995 7.55256 12.1802 6.43327 10.7995 6.43327C9.41877 6.43327 8.29948 7.55256 8.29948 8.93327C8.29948 10.314 9.41877 11.4333 10.7995 11.4333Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.2a413012de327c7dd7de21fc759f8790.svg";
export { ForwardRef as ReactComponent };